import { render } from "./Objects.vue?vue&type=template&id=07eabe96&scoped=true"
import script from "./Objects.vue?vue&type=script&lang=js"
export * from "./Objects.vue?vue&type=script&lang=js"

import "./Objects.vue?vue&type=style&index=0&id=07eabe96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07eabe96"]])

export default __exports__